import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

:root {
    --primary-color:#ba9036;
    --primary-color-light: #ba9036;
    --secondary-color: #6c757d;
    --background-dark-color: #000;
    --background-dark-grey:rgba(30, 56, 37, 0.48);
    --border-color:#ba903644;
    --background-light-color: #F1F1F1;
    --background-light-color-2: rgba(29, 131, 29, 0.63);
    --white-color:rgb(202, 201, 201);
    --font-light-color:#F1F1F1;
    --font-dark-color: #313131;
    --font-dark-color-2: #151515;
    --sidebar-dark-color: #191D2B;
    --scrollbar-bg-color: #383838;
    --scrollbar-thump-color: #6b6b6b;
    --scrollbar-track-color: #383838;
    --title-resume-color: #ba9036;
    --title-portfolio-color:#a4acc4;
    --background-item-portfolio: rgba(41, 82, 2, 0.5);
    --title-portfolio-hover-color:rgb(245, 106, 64);
    --background1: #1e3825;
    --background2: linear-gradient(90deg,#1e3825 0%,rgba(0, 0, 0, 1) 100%)
}


*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    list-style: none;
    text-decoration: none;
    font-family: 'Play', sans-serif;
    font-size: 1rem; /* Default for smaller screens like 14" MacBook */
}

/* Larger screens like 24" desktop */
@media screen and (min-width: 1920px) {
    * {
        font-size: 1.1rem;
    }
}
body{
    background-color: var(--background-dark-color);
    
    color: var(--font-light-color);
    transition: all .4s ease-in-out;
}
body::-webkit-scrollbar{
    width: 9px;
    background-color: #383838;
}
body::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #6b6b6b;
}
body::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: #383838;
}
textarea{
    max-width: 100%;
}
a{
    font-family: inherit;
    color: inherit;
    font-size: inherit;
    font-size: 1rem;
}
h1{
    font-size: 4rem;
    color: var(--white-color);
    span{
        font-size: 4rem;
        @media screen and (max-width: 502px){
            font-size: 3rem
        }
    }
    @media screen and (max-width: 502px){
        font-size: 3rem
    }
}
span{
    color: var(--primary-color);
}
h6{
    color: var(--white-color);
    font-size: 1.2rem;
    padding-bottom: .6rem;
}
//Utilities
.u-margin-bottom{
    margin-bottom: 4rem;
}

//Floting Toggler
.light-dark-mode{
    position: fixed;
    right: 0;
    top: 20%;
    margin-right: 5px;
    background-color: var(--background-light-color-2);
    border-radius: 50px;
    width: 5.5rem;
    height: 2.5rem;
    z-index: 15;
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
      display: flex;
      align-items: center;
      font-size: 1.7rem;
      color: var(--white-color);
    }
  }
`;
